export const bottomSheetMobileHeaderGap = 8;